import { cn } from '@/lib/shadcn/utils';

interface PressAndHoldLinkProps {
  url: string;
  className?: string;
}

/** The link as text to long-press, for when copying it was refused. */
export const PressAndHoldLink = ({ url, className }: PressAndHoldLinkProps) => (
  <p className={cn('text-muted-foreground text-xs leading-normal', className)}>
    Couldn’t copy. Press and hold to copy:{' '}
    <span className="text-foreground font-medium break-all select-all">
      {url}
    </span>
  </p>
);
